import { getCookie, setCookie } from "./cookie";

/**
 * Looks up and returns the device ID stored in the `oai-did` cookie.
 * If the cookie does not exist, a new UUID is generated and persisted.
 */
export function getOrSetDeviceId(): string {
  const deviceIdCookie = getCookie("oai-did");
  if (deviceIdCookie) {
    return deviceIdCookie;
  }

  const newDeviceId = crypto.randomUUID();
  setCookie("oai-did", newDeviceId);

  return newDeviceId;
}
